export const ROUTER_NAMES = Object.freeze({
  BECOME_COACH: "BECOME COACH",
  BOOTCAMP: "Bootcamp",
  BOOTCAMP_CONFIRM: "Bootcamp Confirm",
  BOOTCAMP_ENROLL: "Bootcamp Enroll",
  BOOTCAMP_ENROLL_STATIC: "Bootcamp Enroll Static",
  BOOTCAMPS: "Bootcamps",
  CAREERS: "Careers",
  COACH_APPLICATION: "Coach Application",
  COACH_PROFILE: "COACH PROFILE",
  COACH_TERMS: "Coach Terms and Conditions",
  COACHES: "Coaches",
  COACHING_GPA_FEEDBACK: "Coaching Gameplay Analysis Feedback",
  COACHING_LANDING: "COACHING LANDING",
  COACHING_SESSION_REPORT_CARD: "Coaching Session Report Card",
  COURSE_PAGE: "Course Page",
  COURSES_PAGE: "Courses Page",
  DASHBOARD: "Dashboard",
  ERROR_404: "404",
  FORGOT_PASSWORD: "Forgot Password",
  GIFT: "Gift",
  HOME: "Home",
  HOME_GAME: "Home Game",
  LOGIN: "Login",
  LOL_CHAMPIONS: "LoL Champions",
  OAUTH_APPROVE: "OAuth2 Approve",
  POINT_STORE: "Point Store",
  PRIVACY: "Privacy",
  PRODUCT_CODE_REDEMPTION: "Product Code Redemption",
  REGISTER: "Register",
  SSBU_CHARACTER_PAGE: "SSBU Character Page",
  SSBU_TIER_LIST: "SSBU Tier List",
  SUBSCRIPTION: "Subscriptions Checkout",
  TERMS: "Terms and Condition",
})

export const ROUTER_PATHS = Object.freeze({
  LOGIN: "/login",
  OAUTH_APPROVE: "/oauth/approve",
  OAUTH_LOGIN: "/oauth/login",
})



// WEBPACK FOOTER //
// ./src/constants/router.constants.js